import { images } from '../constants';

const services = [
    {
        id: 1,
        image: images.service1,
        title: 'General {Contracting}',
        content: 'Comprehensive project management and construction services tailored to your needs, ensuring quality.',
        paragraphs: [
            'We provide top-tier general contracting services to bring your construction projects to life. From residential to commercial buildings, our skilled team ensures every aspect of your project is handled with precision and professionalism.',
            'Our services include project management, site preparation, structural work, renovations, and more. Whether you need a new build, remodeling, or repair services, we deliver reliable and high-quality solutions tailored to your needs.'
        ],
        gallery: [
            images.service1Gallery1,
            images.service1Gallery2
        ],
        features: [
            'Experienced Construction Professionals',
            'Comprehensive Project Management',
            'Quality Materials & Workmanship',
            'On-Time Project Completion',
            'Customized Construction Solutions'
        ],
        process: [
            'Initial Consultation & Project Planning',
            'Site Preparation & Foundation Work',
            'Structural Construction & Installations',
            'Quality Inspections & Safety Compliance',
            'Final Touches & Project Completion'
        ],
        faqs: [
            {
                id: 1,
                heading: 'What types of construction projects do you handle?',
                content: 'We handle a wide range of projects, including residential, commercial, and industrial construction. From new builds to renovations and remodels, we offer customized solutions to meet your needs.'
            },
            {
                id: 2,
                heading: 'Do you provide project management services?',
                content: 'Yes, we offer complete project management services to oversee timelines, budgets, and quality control, ensuring smooth and successful project completion.'
            },
            {
                id: 3,
                heading: 'How long does a construction project take?',
                content: 'The timeline depends on the project size, complexity, and scope. We provide detailed project schedules and keep clients updated throughout the construction process.'
            },
            {
                id: 4,
                heading: 'Do you offer warranties on your construction work?',
                content: 'Yes, we provide warranties to guarantee the quality of our work. Our goal is to deliver long-lasting and durable construction solutions.'
            }
        ]
    },
    {
        id: 2,
        image: images.service2,
        title: 'Residential {Construction}',
        content: 'Expert home building solutions, from foundations to finishing touches, designed for durability and comfort.',
        paragraphs: [
            'Our residential construction services cover everything from concept to completion. We specialize in building homes that are not only structurally sound but also reflect your unique lifestyle and preferences.',
            'From laying strong foundations to crafting beautiful interiors, our skilled team ensures quality workmanship at every stage of the project. We work closely with you to bring your vision to life while adhering to timelines and budgets.'
        ],
        gallery: [
            images.service2Gallery1,
            images.service2Gallery2
        ],
        features: [
            'Custom Home Design & Construction',
            'Energy-Efficient Building Practices',
            'High-Quality Materials & Finishes',
            'Experienced & Licensed Builders',
            'Full-Service Project Management'
        ],
        process: [
            'Client Consultation & Needs Assessment',
            'Architectural Design & Planning',
            'Site Preparation & Foundation Work',
            'Structural Framing & Installations',
            'Final Finishes & Quality Inspection'
        ],
        faqs: [
            {
                id: 1,
                heading: 'Do you build custom homes?',
                content: 'Yes, we specialize in building fully customized homes tailored to your specifications and lifestyle needs.'
            },
            {
                id: 2,
                heading: 'Can you help with home design as well?',
                content: 'Absolutely. We collaborate with architects and designers to create a home that reflects your vision and meets building regulations.'
            },
            {
                id: 3,
                heading: 'How long does residential construction usually take?',
                content: 'Timelines vary depending on the size and complexity of the project, but we provide a clear construction schedule and keep you informed throughout the process.'
            },
            {
                id: 4,
                heading: 'Are your residential buildings energy efficient?',
                content: 'Yes, we incorporate energy-efficient materials and technologies to create comfortable, eco-friendly homes.'
            }
        ]
    },
    {
        id: 3,
        image: images.service3,
        title: 'Commercial {Construction}',
        content: 'Delivering high-quality commercial buildings with modern designs and functional layouts.',
        paragraphs: [
            'We specialize in commercial construction projects that prioritize functionality, aesthetics, and long-term value. Whether it’s retail spaces, office buildings, or industrial facilities, we ensure that every structure is built to meet your business goals.',
            'Our team combines innovation with precision to deliver commercial buildings that are code-compliant, cost-effective, and tailored to your operational needs.'
        ],
        gallery: [
            images.service3Gallery1,
            images.service3Gallery2
        ],
        features: [
            'Modern & Functional Designs',
            'Full Compliance with Building Codes',
            'Time-Efficient Project Delivery',
            'Durable Materials & Engineering',
            'Custom Solutions for Business Needs'
        ],
        process: [
            'Consultation & Requirement Analysis',
            'Architectural Planning & Permitting',
            'Site Preparation & Structural Work',
            'System Installations (HVAC, Electrical, Plumbing)',
            'Final Touches & Project Handover'
        ],
        faqs: [
            {
                id: 1,
                heading: 'What types of commercial buildings do you construct?',
                content: 'We construct various commercial spaces including offices, retail stores, warehouses, and mixed-use buildings.'
            },
            {
                id: 2,
                heading: 'Can you handle large-scale commercial projects?',
                content: 'Yes, our team is equipped to manage large-scale and multi-phase commercial construction projects.'
            },
            {
                id: 3,
                heading: 'Do you assist with permits and approvals?',
                content: 'Absolutely. We help with all necessary permits, zoning, and compliance requirements for a smooth build.'
            },
            {
                id: 4,
                heading: 'How do you ensure the project stays on schedule?',
                content: 'We use detailed project timelines, frequent check-ins, and proactive management to ensure timely completion.'
            }
        ]
    },
    {
        id: 4,
        image: images.service4,
        title: 'Renovation & {Remodeling}',
        content: 'Transform your space with our expert renovation and remodeling services, enhancing aesthetics and functionality.',
        paragraphs: [
            'Whether you’re updating a single room or revamping an entire property, our renovation and remodeling services are tailored to breathe new life into your space. We blend creativity with craftsmanship to achieve stunning results.',
            'From concept to completion, we manage every detail—structural upgrades, layout changes, interior finishes, and more—ensuring your transformed space reflects your style and meets your needs.'
        ],
        gallery: [
          images.service4Gallery1,
          images.service4Gallery2
        ],
        features: [
            'Customized Interior & Exterior Remodeling',
            'Modern Design Integration',
            'High-Quality Finishes & Materials',
            'Minimal Disruption to Daily Life',
            'Full Project Management & Supervision'
        ],
        process: [
            'Initial Assessment & Design Consultation',
            'Budget Planning & Material Selection',
            'Demolition & Structural Adjustments',
            'Installation of New Fixtures & Finishes',
            'Final Walkthrough & Quality Assurance'
        ],
        faqs: [
            {
                id: 1,
                heading: 'What areas do you remodel?',
                content: 'We remodel kitchens, bathrooms, basements, living areas, and even full home or office renovations based on your preferences.'
            },
            {
                id: 2,
                heading: 'Can you help with the design?',
                content: 'Yes, we provide design consultation to ensure the new space matches your vision and lifestyle.'
            },
            {
                id: 3,
                heading: 'Do I need to move out during renovation?',
                content: 'Not always. We work efficiently to minimize disruption, and depending on the scope, you may be able to remain in your home.'
            },
            {
                id: 4,
                heading: 'How long does a typical remodel take?',
                content: 'Timelines vary by project size and complexity, but we provide clear schedules and regular updates throughout the process.'
            }
        ]
    },
    {
        id: 5,
        image: images.service5,
        title: 'Interior {Design}',
        content: 'Innovative design solutions to enhance the appearance and functionality of your home or commercial space.',
        paragraphs: [
            'Our interior design services focus on creating aesthetically pleasing and highly functional environments tailored to your taste and lifestyle. Whether it’s a cozy home makeover or a sleek office setup, we bring your vision to life.',
            'From selecting color schemes and furnishings to space planning and lighting, we blend creativity with practicality to deliver harmonious interiors that elevate your space.'
        ],
        gallery: [
            images.service5Gallery1,
            images.service5Gallery2
        ],
        features: [
            'Personalized Design Concepts',
            'Space Optimization & Layout Planning',
            'Color Palette & Material Selection',
            'Furniture, Lighting & Decor Coordination',
            'Residential & Commercial Interior Expertise'
        ],
        process: [
            'Initial Consultation & Space Evaluation',
            'Mood Board & Concept Presentation',
            'Material & Furniture Selection',
            'On-site Implementation & Styling',
            'Final Reveal & Client Walkthrough'
        ],
        faqs: [
            {
                id: 1,
                heading: 'Do you design both homes and offices?',
                content: 'Yes, we offer customized interior design solutions for residential, commercial, and mixed-use spaces.'
            },
            {
                id: 2,
                heading: 'Can I be involved in the design process?',
                content: 'Absolutely! We collaborate with clients at every stage to ensure the design reflects their vision and preferences.'
            },
            {
                id: 3,
                heading: 'Do you source furniture and decor items?',
                content: 'Yes, we help with sourcing and selecting furniture, decor, lighting, and other elements to complete your interior.'
            },
            {
                id: 4,
                heading: 'How long does the design process take?',
                content: 'The timeline depends on the project’s complexity, but we provide a detailed plan and regular updates throughout.'
            }
        ]
    },
    {
        id: 6,
        image: images.service6,
        title: 'Structural {Engineering}',
        content: 'Providing expert structural design and analysis to ensure safety, durability, and compliance with industry standards.',
        paragraphs: [
            'Our structural engineering services are tailored to meet the specific requirements of each project. We deliver reliable, cost-effective solutions that prioritize safety and longevity, ensuring that every structure is built on a solid foundation.',
            'From load calculations to detailed structural analysis, our team of licensed engineers works closely with architects and contractors to provide plans that are both efficient and code-compliant.'
        ],
        gallery: [
            images.service6Gallery1,
            images.service6Gallery2
        ],
        features: [
            'Comprehensive Structural Design & Analysis',
            'Seismic & Wind Load Considerations',
            'Foundation & Framing Design',
            'Retrofitting & Reinforcement Solutions',
            'Code Compliance & Permit Assistance'
        ],
        process: [
            'Project Consultation & Requirement Gathering',
            'Site Assessment & Load Analysis',
            'Structural Design & Modeling',
            'Collaboration with Architects & Builders',
            'Final Review & Compliance Check'
        ],
        faqs: [
            {
                id: 1,
                heading: 'What types of structures do you design?',
                content: 'We design residential, commercial, and industrial structures, including buildings, bridges, and retaining walls.'
            },
            {
                id: 2,
                heading: 'Do you handle retrofitting and strengthening of existing buildings?',
                content: 'Yes, we provide retrofit solutions for aging structures to enhance strength and comply with updated codes.'
            },
            {
                id: 3,
                heading: 'Are your designs compliant with local building codes?',
                content: 'Absolutely. We ensure that all designs meet or exceed current local and international building standards.'
            },
            {
                id: 4,
                heading: 'Can you work with my architect or contractor?',
                content: 'Yes, we frequently collaborate with architects, contractors, and developers to ensure seamless integration of structural plans.'
            }
        ]
    }
];

export default services;